export default "__VITE_ASSET__f42338b7__"